import { render } from "./index.vue?vue&type=template&id=3f133d1c&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=3f133d1c&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f133d1c"]])

export default __exports__